import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import useUrlQuery from 'hooks/useUrlQuery';
import { getLoginPath } from 'utils/navigation';
import ResetPasswordForm from '../components/ResetPasswordForm';

function ResetPassword() {
  const query = useUrlQuery();
  const token = query.get('oobCode');
  const userId = query.get('userId');

  if (token && userId) {
    return (
      <AuthCard>
        <AuthFormHeader />
        <ResetPasswordForm token={token} />
      </AuthCard>
    );
  }

  return <Navigate to={getLoginPath()} />;
}

export default ResetPassword;
